<template>
  <div class="search-form__holder">
    <div v-show="false">
      <slot></slot>
    </div>
    <div class="search-form search__autocomplete">
      <form action="/search" method="get">
        <input id="query" @input="fetchAutocompleteData" name="query" v-model="inputQuery" :placeholder="$t('What are you looking for?')" type="search" autocomplete="off"/>
        <span class="_loading" v-show="autocompleteLoading"></span>
        <span class="_remove" v-show="autocompleteRemove && !autocompleteLoading" @click="clearSearchInput()"></span>
        <button type="submit" :aria-label="$t('What are you looking for?')"></button>
      </form>
      <div class="search__autocomplete_dropdown" v-show="showAutocomplete">
        <ul v-if="autocompleteData.length > 0">
          <li v-for="(product, index) in autocompleteData" v-if="index < 5">
            <a :href="productHref(product)">
              <span class="image__holder">
                <img v-lazy="productImage(product)" width="50" height="50" :alt="product.name"/>
              </span>
              <span class="_title">{{ product.name }}</span>
              <span class="price__holder">
                <span class="price__final-price">{{ product.final_price_incl_tax.priceFormat() }}</span>
              </span>
            </a>
          </li>
          <li v-if="autocompleteData.length > 5" class="more__results">
            <a :href="`/search?query=${inputQuery}`">{{ $t('More results for {inputQuery}', { inputQuery: inputQuery }) }}</a>
          </li>
        </ul>
        <span class="no__results" v-else>{{ $t('No results found for {inputQuery}', { inputQuery: inputQuery }) }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import {apiClient} from '../shared/services/api-client';

@Component({
  name: 'search-form'
})

export default class extends Vue {
  private inputQuery: string = '';
  protected autocompleteData: Array<object> = [];
  private _throttle: number;
  private autocompleteLoading: boolean = false;
  private autocompleteRemove: boolean = false;
  private showAutocomplete: boolean = false;

  private fetchAutocompleteData(): void {
    clearTimeout(this._throttle);
    this._throttle = window.setTimeout(() => {
      this.autocompleteRemove = this.inputQuery.length > 0;
      if (this.inputQuery.length >= 3) {
        this.autocompleteLoading = true;
        apiClient.get('/api/catalog/search/product/list', {params: {query: this.inputQuery}}).then((response) => {
          this.autocompleteData = response.data.items;
          this.autocompleteLoading = false;

          this.showAutocomplete = true;
        });
      } else {
        this.showAutocomplete = false;
        this.autocompleteLoading = false;
      }
    }, 500);
  }

  private productImage(product): string {
    const image = product.default_image;
    if (!image) {
      return product.default_plp_image || '';
    }
    const sized = image.dimensions?.['70x70'];
    if (sized) {
      return sized;
    }
    if (image.url) {
      return image.url.startsWith('http') ? image.url : `/cdn/resize/70/pub/media/catalog/product${image.url}`;
    }
    return product.default_plp_image || '';
  }

  private productHref(product): string {
    const urlKey = String(product.url_key || '').replace(/^\/+/, '');
    return urlKey ? `/${urlKey}` : '#';
  }

  private clearSearchInput(): void {
    this.inputQuery = '';
    this.showAutocomplete = false;
    this.autocompleteRemove = false;
  }
}
</script>
